import { render, staticRenderFns } from "./SeminarTrailer.vue?vue&type=template&id=3f3ea661&scoped=true&"
import script from "./SeminarTrailer.vue?vue&type=script&lang=js&"
export * from "./SeminarTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ea661",
  null
  
)

export default component.exports